module.exports = __webpack_public_path__ + "img/eg-3.5d5c28a8.png";